var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect, _path26, _rect2, _path27, _path28, _path29, _rect3, _rect4, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _defs, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _rect5, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _rect6, _g2, _path80, _defs2, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _defs3, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _rect7, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ":root svg:not(:target){display:none}")), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 6",
    fill: "none",
    id: "arrow-down-blue",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1 4 4 4-4",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 7",
    fill: "none",
    id: "arrow-down",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1 1.5 4 4 4-4",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "arrow-right-grey",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12h-14m9 5 5-5m-5-5 5 5",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "arrow-right",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24h-28m18 10 10-10m-10-10 10 10",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "arrow-select",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m8 10 4 4 4-4",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "arrow-slider",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m20 32 8-8-8-8",
    stroke: "#A1A1A1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "bell",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 34h4m5-13.3v-.7a7 7 0 0 0-7-7v0a7 7 0 0 0-7 7v.7",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20.7c0 2.75 1.03 5.41 2.87 7.47a.5.5 0 0 1-.36.83h-19.02a.5.5 0 0 1-.36-.83 11.25 11.25 0 0 0 2.87-7.48",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 10,
    r: 4,
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.22 5.56c-1.38-.35-2.8-.54-4.22-.56a19 19 0 1 0 19 19 18.62 18.62 0 0 0-.56-4.22",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "calendar-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6v4m-16-4v4m-8 6h32m0 4v-8a4 4 0 0 0-4-4h-24a4 4 0 0 0-4 4v22a4 4 0 0 0 4 4h12",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m0 8a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m7.5-7.5a.5.5 0 1 0 .5-.5.5.5 0 0 0-.5.5",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m34.59 41.41 8.82-8.82a2 2 0 0 0 0-2.83l-3.17-3.17a2 2 0 0 0-2.83 0l-8.82 8.82a2 2 0 0 0-.59 1.42v5.17h5.17a2 2 0 0 0 1.42-.59v0Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "calendar-hover",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4m-8-4v4m-5 3h18",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 4h-14a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-13a2 2 0 0 0-2-2Z",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.01 12.73a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m5 0a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m-10 4a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m5 0a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "calendar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4m-8-4v4m-5 3h18",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 4h-14a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-13a2 2 0 0 0-2-2Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.01 12.73a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m5 0a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m-10 4a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m5 0a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "cardio",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 42.5h-20m-6-30v-2a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v10h-8l-4.8-6.56-6.4 13.12-4.8-6.56h-8v10a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4v-2",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "chat-bubble-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.14 32.45a17.55 17.55 0 0 1-7.46.2l-6.28 3.08v-5.69c-3.88-2.63-6.4-6.81-6.4-11.56 0-8.03 7.2-14.48 16-14.48s16 6.45 16 14.48c0 1.96-.44 3.83-1.21 5.53",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44a10 10 0 1 1 0-20 10 10 0 0 1 0 20",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m38.44 31.78-5.55 5.55-3.33-3.33",
    stroke: "#3C00FF",
    strokeWidth: 3.059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.35 18.42a.5.5 0 1 1-.7.7.5.5 0 1 1 .7-.7m7.11 0a.5.5 0 1 1-.7.7.5.5 0 1 1 .7-.7m-14.22 0a.5.5 0 1 1-.7.7.5.5 0 1 1 .7-.7",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "chat-bubble",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m20.2 38.6-7 3.6v-6.4c-4.4-3.2-7.2-7.8-7.2-13.2 0-9 8-16.4 18-16.4s18 7.2 18 16.4v0c0 9-8 16.4-18 16.4-1.2 0-2.6-.2-3.8-.4",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 27.4a11.1 11.1 0 0 1-15.8 0m4-10v2m8-2v2",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 10",
    fill: "none",
    id: "check",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.828,
    y: 3.192,
    width: 6.936,
    height: 2.585,
    rx: 1.292,
    transform: "rotate(45 1.828 3.192)",
    fill: "#3C00FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9c.5.51 1.32.51 1.82 0l6.27-6.26a1.3 1.3 0 1 0-1.83-1.83l-6.27 6.27c-.5.5-.5 1.32 0 1.83Z",
    fill: "#3C00FF"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 10",
    fill: "none",
    id: "checkbox",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.828,
    y: 3.192,
    width: 6.936,
    height: 2.585,
    rx: 1.292,
    transform: "rotate(45 1.828 3.192)",
    fill: "#3C00FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9c.5.51 1.32.51 1.82 0l6.27-6.26a1.3 1.3 0 1 0-1.83-1.83l-6.27 6.27c-.5.5-.5 1.32 0 1.83Z",
    fill: "#3C00FF"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "clock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 21v0a9 9 0 0 0 9-9v0a9 9 0 0 0-9-9v0a9 9 0 0 0-9 9v0a9 9 0 0 0 9 9Z",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m14 14-2-2v-3m-6.5 3h.5m12.5 0h-.5m-10.24 4.24-.36.36m8.84-8.84.36-.36m-4.6 10.6v.5m0-13v.5m4.24 10.24.36.36m-9.2-9.2.36.36",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "close-popup",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.636,
    y: 16.95,
    width: 16,
    height: 2,
    rx: 1,
    transform: "rotate(-45 5.636 16.95)",
    fill: "#A1A1A1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    rx: 1,
    transform: "scale(-1 1) rotate(-45 11.278 30.642)",
    fill: "#A1A1A1"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "close",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m8 8 8 8m0-8-8 8",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "diploma-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.34h12m-16 8h20",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.89 30.36a5.5 5.5 0 1 1-7.78 7.78 5.5 5.5 0 0 1 7.78-7.78",
    stroke: "#3C00FF",
    strokeWidth: 2.963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m29.5 34.25 5.5 5.5-5.25 5.25-5.27-5.27m-.96 0-5.27 5.27-5.25-5.25 5.5-5.5",
    stroke: "#3C00FF",
    strokeWidth: 2.963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13 39.75h-3a4 4 0 0 1-4-4v-26.75a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v26.75a4 4 0 0 1-4 4h-3",
    stroke: "#3C00FF",
    strokeWidth: 2.963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "diploma",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.67h6m-8 4h10",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M13.94 15.18a2.75 2.75 0 1 1-3.88 3.89 2.75 2.75 0 0 1 3.88-3.89",
    stroke: "#3C00FF",
    strokeWidth: 1.482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m14.75 17.13 2.75 2.75-2.63 2.62-2.63-2.64m-.48 0-2.63 2.64-2.63-2.63 2.75-2.75",
    stroke: "#3C00FF",
    strokeWidth: 1.482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19.88h-1.5a2 2 0 0 1-2-2v-13.38c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v13.38a2 2 0 0 1-2 2h-1.5",
    stroke: "#3C00FF",
    strokeWidth: 1.482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "document-clip",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20v-10a4 4 0 0 0-4-4h-26a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h14m-10-26h18m-18 8h8m-8 8h6",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36 36v-7a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v7a6 6 0 0 1-6 6v0a6 6 0 0 1-6-6v-6",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 134 133",
    fill: "none",
    id: "experts-all",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#experts-all_0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.34 90.25-8.85 4.27-1.5-3.2a3.74 3.74 0 0 1-.42-1.7c.02-.5.15-.94.4-1.31.26-.38.6-.67 1.04-.88.37-.18.71-.26 1.03-.25.31.01.6.1.86.25s.48.34.68.57l.08-.04c-.12-.3-.15-.63-.11-1 .04-.36.18-.7.41-1.04a2.7 2.7 0 0 1 1.04-.84c.45-.22.9-.31 1.37-.28.45.04.89.22 1.3.56.42.33.78.84 1.1 1.51l1.58 3.36v.02Zm-5.64 1.1-.83-1.77a2 2 0 0 0-.55-.72c-.23-.18-.47-.3-.75-.34a1.5 1.5 0 0 0-.84.15 1.4 1.4 0 0 0-.75.83c-.12.37-.07.82.18 1.34l.84 1.8 2.7-1.3Zm3.88-1.87-.9-1.9c-.3-.64-.63-1.04-1-1.2a1.33 1.33 0 0 0-1.13.05 1.64 1.64 0 0 0-.94 1.45c-.02.32.06.66.22 1.01l.92 1.96 2.83-1.37Zm-10.36-13.78.37 1.42a2.36 2.36 0 0 0-1.38 2.07 3 3 0 0 0 .88 2.23c.38.35.87.58 1.46.68.59.1 1.27.05 2.03-.16.77-.2 1.4-.5 1.86-.9.47-.38.79-.83.95-1.33a2.9 2.9 0 0 0-.3-2.37 2.27 2.27 0 0 0-1.29-1.02 2.31 2.31 0 0 0-.88-.1l-.36-1.43c.48-.04.95-.01 1.4.1a3.64 3.64 0 0 1 2.17 1.55c.26.4.46.85.6 1.37.2.81.19 1.59-.04 2.33-.23.75-.66 1.4-1.29 1.96a6.1 6.1 0 0 1-2.46 1.26 5.85 5.85 0 0 1-2.75.15 4.04 4.04 0 0 1-3.19-3.06c-.12-.5-.17-.98-.14-1.45a3.82 3.82 0 0 1 2.37-3.3h-.01Zm6.13-4.09-9.74.85-.41-6.08 1.26-.1.31 4.6 2.97-.25-.29-4.3 1.27-.11.29 4.3 2.98-.26-.32-4.68 1.26-.1.42 6.13Zm-4.95-22.14-.3 1.46a2.35 2.35 0 0 0-2.12 1.3 2.8 2.8 0 0 0-.3.84 2.7 2.7 0 0 0 .13 1.56c.2.48.53.9 1.02 1.24a4.6 4.6 0 0 0 1.9.72 4.8 4.8 0 0 0 2.04-.03 2.8 2.8 0 0 0 2.12-2.22c.06-.3.07-.6.05-.88-.03-.29-.1-.56-.23-.81a2.2 2.2 0 0 0-1.23-1.13l.3-1.46a3.6 3.6 0 0 1 2.49 3.02 4.6 4.6 0 0 1-1.08 3.62c-.53.58-1.2.99-2 1.23a5.8 5.8 0 0 1-2.74.1 5.75 5.75 0 0 1-2.53-1.02 4.04 4.04 0 0 1-1.55-4.15c.1-.52.27-.98.5-1.4a3.94 3.94 0 0 1 2.06-1.77 4.1 4.1 0 0 1 1.46-.23Zm1.04-11.71 9.03 3.5-.56 1.38-7.86-3.06-1.75 4.27 7.87 3.06-.56 1.37-9.03-3.51 2.86-7.01Zm10.41.99-8.22-5.1 3.31-5.2 1.07.66-2.51 3.95 2.5 1.55 2.34-3.68 1.06.66-2.34 3.68 2.51 1.56 2.55-4 1.06.66-3.34 5.26h.01Zm4.83-7.31-7.1-6.53.96-1.05 6.18 5.68 3.23-3.49-6.18-5.68.97-1.04 7.1 6.52-5.16 5.58Zm5-7.28 2.54 2.5-1.01 1.1-1.68-1.54-.47.5-.95-.87 1.56-1.69Zm-3.01-8.38 1.19-.86 4.15 5.74.06-.06-.08-8.68 1.11-.81 5.65 7.82-1.2.87-4.15-5.74-.06.06.08 8.68-1.1.8-5.65-7.82Zm15.2 1.43-1.42.67-.8-10.3 1.55-.73 7.21 7.29-1.42.67-5.8-6.02-.07.03.76 8.38v.01Zm-1.33-3.56 4.63-2.17.5 1.12-4.62 2.17-.51-1.12Zm9.06.05-.29-1.23.27-.08c.38-.1.65-.3.81-.61.16-.3.23-.74.2-1.31a17.3 17.3 0 0 0-.33-2.24l-.89-4.47 6.01-1.54 2.24 9.43-1.41.36-1.96-8.22-3.24.83.7 3.64c.2 1.02.3 1.89.3 2.62 0 .73-.15 1.32-.46 1.77-.3.45-.82.76-1.54.95l-.4.1Zm10.37-12.22 1.46-.08.26 7.14h.09l4.7-7.42 1.36-.08.36 9.72-1.47.09-.26-7.14h-.1l-4.69 7.42-1.35.08-.37-9.72Zm19.99 4.01-1.47-.2a2.25 2.25 0 0 0-1.33-2.05 2.85 2.85 0 0 0-2.42-.03c-.48.21-.89.57-1.23 1.08-.33.5-.57 1.14-.7 1.92a4.7 4.7 0 0 0 .07 2.04 2.67 2.67 0 0 0 2.25 1.99c.3.04.6.04.9 0a2.58 2.58 0 0 0 1.47-.79c.2-.21.35-.47.45-.77l1.47.21a4 4 0 0 1-1.69 2.15 4.06 4.06 0 0 1-2.8.53 4.16 4.16 0 0 1-2.14-.9 4.05 4.05 0 0 1-1.27-1.93c-.25-.8-.3-1.7-.13-2.73.16-1.03.5-1.88.99-2.57a4.28 4.28 0 0 1 4.14-1.77c.5.07.97.2 1.4.42a3.72 3.72 0 0 1 1.8 1.96c.17.43.25.92.25 1.45v-.01Zm3.64-1.06.43-1.2 7.12 2.4-.44 1.2-2.86-.97-2.87 8.03-1.38-.46 2.86-8.03-2.86-.97Zm10.2 6.75 2.26 1.32c.62.37 1.08.78 1.39 1.23a2.58 2.58 0 0 1 .02 2.96c-.3.5-.68.88-1.13 1.13-.47.24-.98.35-1.54.31a4.08 4.08 0 0 1-1.78-.6l-3.12-1.83 5.08-8.43 1.26.74-4.44 7.35 1.86 1.1c.36.2.71.31 1.05.32a1.76 1.76 0 0 0 1.53-.84c.23-.38.28-.79.16-1.23-.12-.44-.46-.82-1-1.13l-2.25-1.32.65-1.07Zm9.25.83-5.08 8.42-1.26-.74 5.08-8.42 1.26.74Zm13.61 29.74 8.85-4.27 1.5 3.2c.3.63.44 1.19.42 1.7a2.46 2.46 0 0 1-1.44 2.19c-.37.18-.71.26-1.03.25-.31-.01-.6-.1-.86-.25a2.69 2.69 0 0 1-.68-.57l-.08.04c.12.3.15.63.11 1-.04.36-.18.7-.41 1.04a2.7 2.7 0 0 1-1.04.84c-.45.22-.9.31-1.37.28a2.34 2.34 0 0 1-1.3-.56 4.25 4.25 0 0 1-1.1-1.51l-1.58-3.36v-.02Zm5.64-1.1.83 1.77a2 2 0 0 0 .55.72c.22.18.47.3.75.33.27.04.56 0 .84-.14.37-.18.62-.45.75-.83.12-.37.07-.82-.18-1.34l-.84-1.81-2.7 1.3Zm-3.88 1.87.9 1.9c.3.64.63 1.04 1 1.2.38.15.76.13 1.13-.05a1.64 1.64 0 0 0 .94-1.45c.02-.32-.06-.66-.22-1.01l-.92-1.96-2.83 1.37Zm10.36 13.78-.37-1.42a2.37 2.37 0 0 0 1.38-2.07 3 3 0 0 0-.88-2.23 2.8 2.8 0 0 0-1.46-.68 4.7 4.7 0 0 0-2.03.16c-.77.2-1.4.5-1.86.9-.47.38-.79.83-.95 1.33a2.9 2.9 0 0 0 .3 2.37 2.28 2.28 0 0 0 2.17 1.11l.36 1.44c-.48.04-.95.01-1.4-.1a3.64 3.64 0 0 1-2.17-1.55c-.26-.4-.46-.85-.6-1.37-.2-.81-.19-1.59.04-2.34.23-.74.66-1.39 1.29-1.95a6.05 6.05 0 0 1 2.46-1.26 5.85 5.85 0 0 1 2.75-.15 4.04 4.04 0 0 1 3.19 3.06c.12.5.17.98.14 1.45a3.85 3.85 0 0 1-2.37 3.3h.01Zm-6.13 4.09 9.74-.86.41 6.09-1.26.1-.31-4.61-2.97.26.29 4.3-1.27.11-.29-4.3-2.98.26.32 4.68-1.26.1-.42-6.13Zm4.95 22.14.3-1.46a2.35 2.35 0 0 0 2.12-1.3 2.83 2.83 0 0 0 .17-2.4 2.8 2.8 0 0 0-1.02-1.24 4.6 4.6 0 0 0-1.9-.72 4.8 4.8 0 0 0-2.04.03 2.81 2.81 0 0 0-2.12 2.22c-.06.3-.07.6-.05.88.03.29.1.56.23.81a2.21 2.21 0 0 0 1.23 1.13l-.3 1.46a3.6 3.6 0 0 1-2.49-3.02 4.6 4.6 0 0 1 1.08-3.62 4.4 4.4 0 0 1 2-1.24 5.93 5.93 0 0 1 2.75-.1c1.02.18 1.86.53 2.52 1.03a4.05 4.05 0 0 1 1.55 4.15c-.1.51-.27.98-.5 1.4a3.95 3.95 0 0 1-2.06 1.77c-.44.16-.93.24-1.46.23Zm-1.04 11.71-9.03-3.51.56-1.37 7.86 3.06 1.75-4.27-7.87-3.06.56-1.37 9.03 3.51-2.86 7v.01Zm-10.41-.99 8.22 5.1-3.31 5.2-1.07-.66 2.51-3.95-2.5-1.55-2.34 3.68-1.06-.66 2.34-3.68-2.51-1.56-2.55 4-1.06-.66 3.34-5.26h-.01Zm-4.83 7.31 7.1 6.53-.96 1.05-6.18-5.68-3.23 3.49 6.18 5.68-.97 1.04-7.1-6.52 5.16-5.58Zm-5 7.28-2.54-2.5 1.01-1.1 1.68 1.54.47-.5.95.87-1.56 1.69Zm3.01 8.38-1.19.86-4.15-5.74-.06.06.08 8.68-1.1.81-5.66-7.82 1.2-.88 4.15 5.75.06-.06-.08-8.68 1.1-.8 5.65 7.82Zm-15.2-1.43 1.42-.67.8 10.3-1.55.73-7.21-7.29 1.42-.67 5.8 6.02.07-.03-.76-8.38v-.01Zm1.33 3.56-4.63 2.17-.5-1.12 4.62-2.17.51 1.12Zm-9.06-.05.29 1.23-.27.08c-.38.1-.65.3-.81.61-.16.3-.23.74-.2 1.31.04.57.14 1.32.33 2.24l.89 4.47-6.01 1.54-2.24-9.43 1.41-.36 1.96 8.22 3.24-.83-.7-3.64a14 14 0 0 1-.3-2.62c0-.73.15-1.32.46-1.77.3-.45.82-.77 1.54-.95l.4-.1Zm-10.37 12.21-1.46.09-.26-7.14h-.09l-4.7 7.42-1.36.08-.36-9.72 1.47-.09.26 7.14h.1l4.69-7.42 1.35-.08.37 9.72Zm-19.99-4 1.47.2a2.25 2.25 0 0 0 1.33 2.05c.26.12.55.2.86.25a2.8 2.8 0 0 0 2.79-1.3c.33-.5.57-1.14.7-1.92a4.7 4.7 0 0 0-.07-2.04 2.76 2.76 0 0 0-.84-1.37 2.67 2.67 0 0 0-1.41-.62 3.1 3.1 0 0 0-.9 0 2.57 2.57 0 0 0-1.47.79c-.2.21-.35.47-.45.77l-1.47-.21a3.99 3.99 0 0 1 1.69-2.15 4.06 4.06 0 0 1 2.8-.53c.84.11 1.56.42 2.14.9a4.05 4.05 0 0 1 1.27 1.93c.25.8.3 1.7.13 2.73a5.97 5.97 0 0 1-.99 2.57 4.27 4.27 0 0 1-4.14 1.77c-.5-.07-.97-.2-1.4-.42a3.7 3.7 0 0 1-1.8-1.96 3.94 3.94 0 0 1-.25-1.45v.01Zm-3.64 1.06-.43 1.2-7.12-2.4.44-1.2 2.86.97 2.87-8.03 1.38.46-2.86 8.03 2.86.97Zm-10.2-6.76-2.26-1.31a4.19 4.19 0 0 1-1.39-1.23 2.58 2.58 0 0 1-.02-2.96c.3-.5.68-.88 1.13-1.13.47-.25.98-.35 1.54-.31.57.04 1.16.24 1.78.6l3.12 1.83-5.08 8.43-1.26-.74 4.44-7.35-1.86-1.1a2.16 2.16 0 0 0-1.05-.32c-.33 0-.63.07-.9.22-.26.15-.47.37-.63.62a1.5 1.5 0 0 0-.16 1.23c.12.44.46.82 1 1.13l2.25 1.32-.65 1.07Zm-9.25-.82 5.08-8.42 1.26.74-5.08 8.42-1.26-.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 67,
    cy: 66,
    r: 50,
    fill: "#3C00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 66h-28m18 10 10-10m-10-10 10 10",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "experts-all_0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h134v133h-134z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "filter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5h3m-18 0h8m2 7h8m-18 0h3m12 7h3m-18 0h8m6.41-15.41a2 2 0 1 1-2.82 2.82 2 2 0 0 1 2.82-2.82m-8 7a2 2 0 1 1-2.82 2.82 2 2 0 0 1 2.82-2.82m8 7a2 2 0 1 1-2.82 2.82 2 2 0 0 1 2.82-2.82",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "glasses-book",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42 40h-32a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4h32m-2 6h-28",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.57 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm18.86 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 14a4.29 4.29 0 0 1 6.86 0m-21.43 0h2.56m30.88 0h2.57",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "glasses",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.47 14.03a3.5 3.5 0 1 1-4.95 4.94 3.5 3.5 0 0 1 4.95-4.94",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m17.9 4 1.67 1.14a2 2 0 0 1 .86 1.44l1.03 9.42m-12.99-1.97a3.5 3.5 0 1 1-4.94 4.94 3.5 3.5 0 0 1 4.94-4.94",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.47a2.44 2.44 0 0 1 2.5-2.37c1.38 0 2.5 1.06 2.5 2.37m-8.4-12.47-1.67 1.14a2 2 0 0 0-.86 1.44l-1.03 9.42",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "globe-open-book",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03 18h33.94m-16.97 24c-4.42 0-8-8.06-8-18s3.58-18 8-18m0 24h-16.97",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42a18 18 0 0 1 0-36m13 25.65a12.46 12.46 0 0 1 5.97-1.65 1 1 0 0 1 1.03 1v8.1c0 .66-.5 1.2-1.16 1.24-2.06.02-4.08.6-5.84 1.66m0-10.35a12.46 12.46 0 0 0-5.97-1.65 1 1 0 0 0-1.03 1v8.34a1 1 0 0 0 1 1c2.11 0 4.19.57 6 1.66m0-10.35v10.35m-5-18c0-9.94-3.58-18-8-18",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M42 24a18 18 0 0 0-18-18",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "graduate-hat-shield",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.88 41.79v0a19.76 19.76 0 0 1-15.88-19.37v-6.42a10 10 0 0 1 10-10h16a10 10 0 0 1 10 10v6.42c0 9.41-6.65 17.52-15.88 19.37h0c-1.4.28-2.84.28-4.24 0v0Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.91v5.2a3 3 0 0 0 1.66 2.68l1.16.58a6 6 0 0 0 5.36 0l1.16-.58a3 3 0 0 0 1.66-2.69v-5.19",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.14 21.3 6.7 3.21a5 5 0 0 0 4.32 0l6.7-3.2a2 2 0 0 0 0-3.61l-6.7-3.21a5 5 0 0 0-4.32 0l-6.7 3.2a2 2 0 0 0 0 3.61Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M34 19.49v4.51",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "health",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M24.5 10.35a10.69 10.69 0 0 1 8.32-3.85c7.14 0 11.93 6.7 11.93 12.95 0 13.05-16.25 23.05-20.25 23.05s-20.25-10-20.25-23.05c0-6.25 4.8-12.95 11.93-12.95a10.7 10.7 0 0 1 8.32 3.85Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 23.5h4.44l3.34-5 4.44 10 3.34-5h4.44",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 29",
    fill: "none",
    id: "heart",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.82 27c6.9-3.85 11.99-7.08 15.84-13.4 6.1-9.98-10.43-17.69-13-4.9m-1.62 14.45c-3.8-1.91-12.82-7.87-11.99-14.33 1.16-8.98 11.32-6.55 13.61 0",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "kids",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 32.5,
    width: 32,
    height: 10,
    rx: 3,
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 32.67v-6.17a14 14 0 0 0-14-14v0a14 14 0 0 0-14 14v6.17m6-.17v10m8-10v10m8-10v10",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28.08 12.98a5 5 0 1 0-7.16 0",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "knife",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m4.5 40 30.15-30.15a4.6 4.6 0 0 1 6.5 0v0a4.6 4.6 0 0 1-.4 6.86l-11.78 9.28",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m23.75 20.79 8.18 8.17a1 1 0 0 1 0 1.42l-3.74 3.73c-8.18 8.18-18.78 10.83-23.69 5.93m0 0v-.04",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    id: "left-achievement",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46 17.73h.09a1.5 1.5 0 0 1 1.5 1.6 3.5 3.5 0 0 1-3.47 3.35 1.5 1.5 0 0 1-1.5-1.6 3.5 3.5 0 0 1 3.38-3.35Zm.09 1.5a2.01 2.01 0 0 1-1.97 1.95 2.01 2.01 0 0 1 1.97-1.95Zm-7.73-4.5c.7-.61 1.52-.94 2.4-.94.85 0 1.67.32 2.36.92a1.5 1.5 0 0 1 0 2.26c-.69.61-1.51.94-2.38.94a3.6 3.6 0 0 1-2.37-.92 1.5 1.5 0 0 1 0-2.26Zm3.77 1.11a2.1 2.1 0 0 0-1.38-.55c-.48 0-.97.2-1.4.57.43.36.91.55 1.4.55.48 0 .96-.2 1.38-.57Zm-4.13-8.43a1.5 1.5 0 0 1 1.17-.42 3.52 3.52 0 0 1 3.34 3.44 1.5 1.5 0 0 1-1.62 1.57 3.52 3.52 0 0 1-3.34-3.43 1.5 1.5 0 0 1 .45-1.16Zm1.05 1.08c1.14.09 1.9.88 1.96 2.01a2.04 2.04 0 0 1-1.96-2.01Zm3.17-6.67c.28-.32.7-.5 1.12-.5h.01c.43 0 .84.19 1.13.51a3.58 3.58 0 0 1-.02 4.87 1.5 1.5 0 0 1-2.26-.01 3.58 3.58 0 0 1 .02-4.87Zm1.12 1a2.1 2.1 0 0 1 0 2.89 2.1 2.1 0 0 1 0-2.9Z",
    fill: "#323232"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    id: "login-enter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5h-10m7 3 3-3-3-3",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95 16.5a9 9 0 1 0 0-8",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "loss",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 32.5h-5.02a6 6 0 0 0-4.07 1.6l-.13.12a6.45 6.45 0 0 0-1.61 2.34l-.7 1.76m13.9-11.45a6.94 6.94 0 0 0 4.63-6.53 7 7 0 0 0-7-7 6.94 6.94 0 0 0-6.53 4.63",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42 16.42a18 18 0 0 0 24.16 24.16m-20.81-28.81v0a18 18 0 1 1 25.46 25.46m3.27 3.27-32-32",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "mail",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27.52v-15.45m-13.94 23.93h-16.06a6 6 0 0 1-6-6v-17.93",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m18.27 22.04-12.1-6.38a4.07 4.07 0 0 1-2.17-3.6v-.06a4 4 0 0 1 4-4h27.93a4.07 4.07 0 0 1 4.07 4.07v.04a4 4 0 0 1-2.14 3.54l-12.13 6.39a8 8 0 0 1-7.46 0Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m38.5 33.3-4.38 4.38-2.62-2.63",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M41.36 28.64a9.05 9.05 0 0 1 0 12.77 9.12 9.12 0 0 1-12.73 0 9.05 9.05 0 0 1 0-12.77 8.98 8.98 0 0 1 12.73 0",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "message-love",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m31.73 26 4.64 3.77a1 1 0 0 0 1.63-.77v-3a6 6 0 0 0 6-6v-10a6 6 0 0 0-6-6h-12a6 6 0 0 0-6 6v10a6 6 0 0 0 6 6h5.73Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32v2a6 6 0 0 1-6 6h-5.73l-4.64 3.77a1 1 0 0 1-1.63-.77v-3a6 6 0 0 1-6-6v-8a6 6 0 0 1 6-6h4",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m31.66 11.03.34.35.35-.37a3.19 3.19 0 0 1 4.61-.05l.07.07a3.42 3.42 0 0 1 0 4.77l-3.5 3.56a2.14 2.14 0 0 1-3.05 0l-3.51-3.56a3.42 3.42 0 0 1 0-4.77v0a3.3 3.3 0 0 1 4.7 0v0Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 30a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0m5 0a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0m5 0a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "message",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.54 17a9 9 0 1 1 3.24 2.94 9.54 9.54 0 0 1-5.78 1.05 9.04 9.04 0 0 0 2.54-3.99Z",
    stroke: "#3C00FF",
    strokeWidth: 1.588,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "money",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m8.5-2.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M34.5 24.5v12a4 4 0 0 1-4 4h-20a4 4 0 0 1-4-4v-12a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m12.9 20.5 2.41-9.04h0a4 4 0 0 1 4.9-2.83l19.33 5.18h0a4 4 0 0 1 2.83 4.9l-3.1 11.6a4 4 0 0 1-4.77 2.85",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 16",
    fill: "none",
    id: "pay",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 0.65,
    width: 35,
    height: 14.7,
    rx: 7.35,
    fill: "#000"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pay_0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95 3.5c-.58 0-1.3.37-1.57.62l.1.24s-.82.01-1.24.28c-.42.28-.61.46-.82.9-.21.01-1 .34-1.45.68 0 0-.38 1.44.34 2.06l-.45.62c.11.4.61.8 1.1.84.22.27-.2.8-.2.8.18.58 1.4 1.22 2.13 1.22l-.1.34s.82.6 2.13.54c1.11.03 2.02-.23 2.25-.54l-.12-.34c1.01-.15 1.78-.48 2.2-1.19 0 0-.31-.67-.2-.83.5-.05.95-.54 1.08-.75l-.45-.7c.36-.4.56-1.46.3-2.07a3.96 3.96 0 0 0-1.44-.62c-.08-.49-.62-.87-.62-.87-.5-.44-1.41-.37-1.41-.37l.07-.24a2.6 2.6 0 0 0-1.63-.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 4.87a1.59 1.59 0 0 0-1.4.34c-.39.28-.54.64-.5.77-.31-.13-1 .27-1.32.46 0 0-.25 1.23.39 1.7-.03.34-.27.74-.4.82.22.33.67.42.86.34.32.44.16 1.03-.01 1.22.5.45 1.67.64 2.02.66 0 0-.3-.7-.44-1.3-.38-1.62-.18-3.64-.18-3.64s-.87 1.02-.38 3.48c.08.41.2.85.2.85-.09-.04-.28-.01-.65-.2.16-.17.09-1.17-.37-1.66 0 0-.22.1-.38.04.1-.07.24-.5.24-.82-.52-.3-.46-.87-.44-1.17.26-.16.72-.44 1.3-.2-.02-.14.02-.5.18-.77 0 0 .19-.33.62-.44.44-.1.66-.48.66-.48Zm2.8 0c.57-.14 1.01.06 1.4.34.37.28.52.64.49.77.31-.13 1 .27 1.32.46 0 0 .25 1.23-.4 1.7.04.34.28.74.4.82-.21.33-.66.42-.85.34a1.08 1.08 0 0 0 0 1.22c-.49.45-1.67.64-2.01.66 0 0 .3-.7.44-1.3.37-1.62.17-3.64.17-3.64s.88 1.02.4 3.48l-.2.85c.07-.04.27-.01.64-.2-.16-.17-.1-1.17.37-1.66 0 0 .22.1.38.04-.11-.07-.25-.5-.25-.82.52-.3.47-.87.44-1.17-.25-.16-.71-.44-1.29-.2.02-.14-.02-.5-.18-.77 0 0-.2-.33-.63-.44-.43-.1-.65-.48-.65-.48Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04 5.82c-.42 0-.97.11-.97.11l-.17-1.65 1.12-.34 1.06.34-.09 1.65s-.54-.1-.95-.1Zm0-.47c-.23 0-.53.04-.53.04l-.07-.79.58-.16.58.16v.79l-.56-.04Zm-.05 6.76a4.2 4.2 0 0 0 1.59-.3l-.38-1.19s-.82.24-1.2.24c-.4 0-1.2-.24-1.2-.24l-.39 1.2s.6.28 1.58.3Zm0-.4c.55 0 .9-.11 1.08-.18l-.1-.41c-.23.07-.63.16-.98.16s-.75-.07-.97-.14l-.1.39c.2.07.52.18 1.07.19Zm1.96-5.26h-3.92c.03.05.16.25.2.37.05.12.08.24.08.31l.02.48.05 1.58c0 .18.04.42.19.62s.4.34.8.34h.28a.1.1 0 0 1 .06.02c.02 0 .03.03.05.05l.04.1a1 1 0 0 0 .05.09l.05.05c.03.02.06.03.1.03l.09-.03.05-.05a.98.98 0 0 0 .05-.1.85.85 0 0 1 .04-.09.16.16 0 0 1 .05-.05.1.1 0 0 1 .06-.02h.28c.4 0 .65-.14.8-.34.14-.2.18-.44.19-.62 0-.41.03-1.1.05-1.58l.02-.48a1.63 1.63 0 0 1 .28-.68Zm-3.17.56-.02-.07h2.47a.6.6 0 0 0-.01.07l-.01.15c-.02.48-.06 1.49-.06 1.99 0 .2-.07.34-.15.42a.45.45 0 0 1-.32.11h-.18c-.12 0-.23 0-.32.02a.44.44 0 0 0-.19.1.69.69 0 0 0-.5-.16h-.21c-.2 0-.42-.17-.42-.5 0-.54-.04-1.46-.05-1.93l-.03-.2Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76 6.94a1.55 1.55 0 0 1 .04.27c.02.47.05 1.39.05 1.94 0 .32.22.5.43.5a7.23 7.23 0 0 1 .2-.01c.2-.01.39.04.5.16a.44.44 0 0 1 .2-.1c.09-.02.2-.03.3-.02a5.71 5.71 0 0 0 .2 0c.1 0 .22-.03.31-.11s.15-.22.15-.42c0-.5.04-1.5.06-2l.01-.14.02-.07h-2.47Z",
    fill: "#FFDD2D"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 5.7h-2.87v4.6h1.4v-1.24h1.46c.35 0 .69-.01 1.02-.12.63-.2 1.1-.77 1.1-1.54a1.6 1.6 0 0 0-1.09-1.55 2.9 2.9 0 0 0-1.03-.14Zm-1.48 2.28v-1.16h1.27c.27 0 .43.02.55.07.22.09.33.3.33.5 0 .23-.13.46-.37.53-.11.04-.25.06-.5.06h-1.28Zm5.59.64.67-1.85h.1l.67 1.85h-1.44Zm-.34 1h2.11l.27.67h1.57l-1.87-4.58h-2.05l-1.87 4.58h1.58l.26-.66Zm7.35-3.92-1.14 2.1h-.04l-1.15-2.1h-1.63l2.07 3.38v1.21h1.45v-1.33l1.96-3.25h-1.52Z",
    fill: "#fff"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pay_0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.86 2.867)",
    d: "M0 0h10.27v10.27h-10.27z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87 12",
    fill: "none",
    id: "payment-card",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4407 4.58939C13.4269 5.67905 14.4118 6.28716 15.1538 6.64868C15.9161 7.01966 16.1722 7.25752 16.1692 7.58922C16.1634 8.09695 15.5611 8.32099 14.9974 8.32972C14.0139 8.34499 13.4422 8.06422 12.9876 7.85181L12.6333 9.50957C13.0894 9.71979 13.9339 9.9031 14.8097 9.9111C16.8654 9.9111 18.2104 8.89637 18.2176 7.32299C18.2256 5.32625 15.4557 5.21569 15.4746 4.32316C15.4811 4.05257 15.7393 3.76378 16.3053 3.69032C16.5853 3.65322 17.3586 3.62485 18.2351 4.02856L18.5791 2.42463C18.1078 2.25296 17.5019 2.08857 16.7475 2.08857C14.8126 2.08857 13.4516 3.11712 13.4407 4.58939ZM21.8852 2.22677C21.5099 2.22677 21.1934 2.44572 21.0523 2.78178L18.1158 9.79326H20.17L20.5788 8.6636H23.0891L23.3262 9.79326H25.1367L23.5568 2.22677H21.8852ZM22.1725 4.27079L22.7654 7.11204H21.1418L22.1725 4.27079ZM10.9501 2.22677L9.33088 9.79326H11.2883L12.9068 2.22677H10.9501ZM8.05428 2.22677L6.01682 7.37682L5.19266 2.99782C5.09592 2.50901 4.71403 2.22677 4.28995 2.22677H0.959152L0.912598 2.44645C1.59636 2.59484 2.37323 2.83416 2.84386 3.09021C3.13192 3.2466 3.21412 3.38335 3.30868 3.75506L4.86969 9.79326H6.93844L10.1099 2.22677H8.05428Z",
    fill: "#1434CB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9736 1.67587H40.1616V10.3236H44.9736V1.67587Z",
    fill: "#FF5F00"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4679 6.00092C40.467 5.16796 40.6557 4.34572 41.0196 3.59646C41.3835 2.8472 41.9131 2.19057 42.5684 1.67629C41.7571 1.0387 40.7828 0.64222 39.7568 0.532166C38.7308 0.422112 37.6946 0.602921 36.7666 1.05393C35.8385 1.50494 35.056 2.20795 34.5086 3.08261C33.9612 3.95728 33.6709 4.96831 33.6709 6.00016C33.6709 7.03201 33.9612 8.04304 34.5086 8.91771C35.056 9.79237 35.8385 10.4954 36.7666 10.9464C37.6946 11.3974 38.7308 11.5782 39.7568 11.4682C40.7828 11.3581 41.7571 10.9616 42.5684 10.324C41.9133 9.80991 41.3838 9.15352 41.0199 8.40454C40.656 7.65557 40.4673 6.83362 40.4679 6.00092Z",
    fill: "#EB001B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4661 6.00076C51.4661 7.03269 51.1758 8.04378 50.6282 8.91848C50.0807 9.79318 49.2981 10.4962 48.37 10.9471C47.4418 11.3981 46.4055 11.5788 45.3794 11.4685C44.3534 11.3583 43.3791 10.9617 42.5679 10.3239C43.2226 9.80929 43.752 9.15272 44.116 8.4037C44.48 7.65469 44.6691 6.83278 44.6691 6C44.6691 5.16722 44.48 4.34531 44.116 3.5963C43.752 2.84728 43.2226 2.19071 42.5679 1.67613C43.3791 1.03834 44.3534 0.64167 45.3794 0.531458C46.4055 0.421246 47.4418 0.601939 48.37 1.05288C49.2981 1.50383 50.0807 2.20682 50.6282 3.08152C51.1758 3.95622 51.4661 4.96731 51.4661 5.99924V6.00076Z",
    fill: "#F79E1B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2246 2.08868H79.0264C79.3292 3.80461 80.9946 5.41959 82.8115 5.41959H86.9499C87.0004 5.26819 87.0003 5.01584 87.0003 4.86444C87.0003 3.35039 85.7386 2.08868 84.2246 2.08868Z",
    fill: "#00B4E6"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4805 5.7225V9.91137H82.0039V7.69076H84.2245C85.4357 7.69076 86.4956 6.83281 86.8488 5.7225H79.4805Z",
    fill: "#4FAD50"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5986 2.08868V9.8608H72.8192C72.8192 9.8608 73.3744 9.8608 73.6772 9.30565C75.1912 6.32802 75.6455 5.41959 75.6455 5.41959H75.9483V9.8608H78.4717V2.08868H76.2511C76.2511 2.08868 75.6959 2.13916 75.3931 2.64384C74.1314 5.21772 73.4249 6.52989 73.4249 6.52989H73.122V2.08868H70.5986Z",
    fill: "#4FAD50"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9995 9.91145V2.13934H62.5229C62.5229 2.13934 63.2295 2.13934 63.6332 3.24964C64.6426 6.1768 64.7435 6.58055 64.7435 6.58055C64.7435 6.58055 64.9454 5.87399 65.8538 3.24964C66.2576 2.13934 66.9641 2.13934 66.9641 2.13934H69.4876V9.91145H66.9641V5.72259H66.6613L65.2482 9.91145H64.1379L62.7248 5.72259H62.422V9.91145H59.9995Z",
    fill: "#4FAD50"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "payment-card_0",
    x1: 78.9045,
    y1: 4.04432,
    x2: 86.727,
    y2: 4.04432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088CCB"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 12",
    fill: "none",
    id: "payment-shares",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M13.67.5h-1.84v9.3h1.84v-9.3Zm-3.95.52h-1.83v9.3h1.83v-9.3Zm-3.94.58h-1.84v9.31h1.84v-9.3Zm-3.94.59h-1.84v9.31h1.84v-9.31Zm60.3 3.27-2.95-3.29h-1.73v7.61h1.8v-4.85l2.7 2.87h.33l2.66-2.87v4.85h1.8v-7.6h-1.73l-2.88 3.28Zm13.2-3.29-4.47 4.95v-4.95h-1.8v7.61h1.65l4.47-4.94v4.94h1.8v-7.6h-1.65Zm-27.6 2.79c0 1.2.67 2.16 1.68 2.56l-1.9 2.26h2.2l1.74-2.05h1.87v2.05h1.8v-7.6h-4.58a2.65 2.65 0 0 0-2.8 2.78Zm5.6-1.11v2.25h-2.46c-.82 0-1.26-.46-1.26-1.13 0-.67.46-1.12 1.26-1.12h2.46Zm-13.98-.15c-.1 2.61-.66 4.3-1.74 4.3h-.27v1.83l.29.01c2.16.12 3.36-1.78 3.56-5.93h2.85v5.87h1.8v-7.6h-6.43l-.06 1.51Zm-6.79-1.63c-2.44 0-4.2 1.69-4.2 3.9 0 2.3 1.92 3.93 4.2 3.93 2.38 0 4.23-1.72 4.23-3.92 0-2.21-1.85-3.91-4.23-3.91Zm0 6c-1.38 0-2.32-.9-2.32-2.1 0-1.23.94-2.1 2.32-2.1s2.35.91 2.35 2.1c0 1.2-.98 2.1-2.35 2.1Zm-6.11-5.88h-6.36l-.06 1.52c-.1 2.2-.67 4.28-1.75 4.3l-.5.02v3.47h1.82v-1.72h6.32v1.72h1.84v-3.48h-1.3v-5.83Zm-1.8 5.83h-3.85c.65-1 1-2.42 1.06-4.1h2.79v4.1Z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 48",
    fill: "none",
    id: "phone",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.76 27.74a25.27 25.27 0 0 1-5.27-7.62 1.5 1.5 0 0 1 .33-1.65l1.64-1.64c1.34-1.34 1.34-3.24.17-4.41l-2.35-2.35a4 4 0 0 0-5.66 0l-1.3 1.3a6.39 6.39 0 0 0-1.7 5.74c.99 5.23 4.02 10.95 8.92 15.85s10.62 7.93 15.85 8.92a6.4 6.4 0 0 0 5.74-1.7l1.3-1.3a4 4 0 0 0 0-5.66l-2.35-2.34a3 3 0 0 0-4.24 0l-1.8 1.8a1.5 1.5 0 0 1-1.66.34 25.36 25.36 0 0 1-7.62-5.28Zm17.4-22.4c2.6 0 4.34 2.36 4.34 4.55 0 4.46-7.23 8.11-7.36 8.11-.13 0-7.36-3.65-7.36-8.1 0-2.2 1.75-4.56 4.34-4.56 1.48 0 2.46.72 3.02 1.35a3.94 3.94 0 0 1 3.02-1.35Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    fill: "none",
    id: "play",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.26795C16.3333 8.03775 16.3333 9.96225 15 10.7321L3 17.6603C1.66667 18.4301 1.01267e-06 17.4678 1.07997e-06 15.9282L1.68565e-06 2.0718C1.75295e-06 0.532196 1.66667 -0.430054 3 0.339746L15 7.26795Z",
    fill: "#3C00FF"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "plus",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16m-8 8v-16",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    fill: "none",
    id: "plus1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.97c3.42-1.14 4.5-2 9-3m-6-3c1.5 4.5.5 4.5 2.5 8.5m6.5-10.5c1.95-2.39 4-11.42 4-8.34 0 4.97 3 10.34 4.5 16.34",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 32",
    fill: "none",
    id: "quote",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.3c0-4.1 3.2-7.3 7.3-7.3 6.01 0 8.44 6.02 8.44 11.78 0 7.8-6.14 15.87-14.08 19.84l-1.53-2.05c4.6-2.82 8.96-7.55 8.96-13.19 0-.76-.13-1.53-.26-2.3a9.9 9.9 0 0 1-1.79.26 7.02 7.02 0 0 1-7.04-7.04Zm21.76 0c0-4.1 3.2-7.3 7.3-7.3 6.01 0 8.44 6.02 8.44 11.78 0 7.8-6.14 15.87-14.08 19.84l-1.53-2.05c4.6-2.82 8.96-7.55 8.96-13.19 0-.76-.13-1.53-.26-2.3a9.9 9.9 0 0 1-1.79.26 7.02 7.02 0 0 1-7.04-7.04Z",
    fill: "#3C00FF"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    id: "right-achievement",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.54 17.73h-.09a1.5 1.5 0 0 0-1.5 1.6 3.5 3.5 0 0 0 3.47 3.35 1.5 1.5 0 0 0 1.5-1.6 3.5 3.5 0 0 0-3.38-3.35Zm-.09 1.5a2.01 2.01 0 0 0 1.97 1.95 2.01 2.01 0 0 0-1.97-1.95Zm7.73-4.5a3.58 3.58 0 0 0-2.4-.94c-.85 0-1.67.32-2.36.92a1.5 1.5 0 0 0 0 2.26c.69.61 1.51.94 2.38.94a3.6 3.6 0 0 0 2.37-.92 1.5 1.5 0 0 0 0-2.26Zm-3.77 1.11c.42-.36.9-.55 1.38-.55.48 0 .97.2 1.4.57-.43.36-.91.55-1.4.55a2.1 2.1 0 0 1-1.38-.57Zm4.13-8.43a1.5 1.5 0 0 0-1.17-.42 3.52 3.52 0 0 0-3.34 3.44 1.5 1.5 0 0 0 1.62 1.57 3.52 3.52 0 0 0 3.34-3.43 1.5 1.5 0 0 0-.45-1.16Zm-1.05 1.08c-1.14.09-1.9.88-1.96 2.01a2.03 2.03 0 0 0 1.96-2.01Zm-3.17-6.67a1.5 1.5 0 0 0-1.12-.5h-.01c-.43 0-.84.19-1.13.51a3.58 3.58 0 0 0 .02 4.87 1.5 1.5 0 0 0 2.26-.01 3.58 3.58 0 0 0-.02-4.87Zm-1.12 1a2.1 2.1 0 0 0 0 2.89 2.1 2.1 0 0 0 0-2.9Z",
    fill: "#323232"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "romance",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M30.62 18.46c-4.3-2.58-9.51-.4-11.68 3.23-4.41 7.37 3.9 20.55 4.14 20.68",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 24.44c4.29 2.57 4.83 8.2 2.65 11.82-4.41 7.35-19.96 6.23-20.17 6.1m11.19-18.68a7.64 7.64 0 0 0-3.65-5.22m3.65 5.22a7.54 7.54 0 0 1 6.33.76m-11.93-6.81a8.8 8.8 0 0 0 .43-5.12c-.89-3.64-4.7-6.85-9-5.81a6.73 6.73 0 0 0-4.47 3.44 6.7 6.7 0 0 0-5.55-1.01c-4.3 1.04-6.26 5.62-5.37 9.26 1.32 5.46 8.98 8.6 13 9.86",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 10",
    fill: "none",
    id: "s",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16 10a5.14 5.14 0 0 1-2.65-.63 3.53 3.53 0 0 1-1.51-1.75l1.78-.94c.42.98 1.23 1.47 2.44 1.47.58 0 1.01-.1 1.28-.3.28-.19.41-.43.41-.72 0-.34-.16-.6-.5-.78-.33-.2-.92-.4-1.78-.62a12.5 12.5 0 0 1-1.21-.39c-.32-.12-.65-.3-.98-.5a2.24 2.24 0 0 1-1-1.98c0-.87.34-1.56 1.01-2.08.69-.52 1.5-.78 2.47-.78.85 0 1.6.2 2.25.58.66.37 1.16.9 1.53 1.58l-1.76.92a2.13 2.13 0 0 0-2.02-1.24c-.44 0-.78.1-1.03.28a.8.8 0 0 0-.36.68c0 .3.13.55.4.74.29.19.82.39 1.6.6a15.99 15.99 0 0 1 2.08.75c.16.1.34.22.54.37.2.16.36.32.46.48a2.78 2.78 0 0 1 .39 1.36c0 .89-.36 1.6-1.07 2.12-.7.52-1.63.78-2.77.78Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "schedule",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14h20m-10 18.33 3 1.58a.8.8 0 0 0 1.17-.85l-.58-3.35 2.44-2.37a.8.8 0 0 0-.45-1.36l-3.36-.49-1.5-3.05a.8.8 0 0 0-1.44 0l-1.5 3.05-3.36.5a.8.8 0 0 0-.45 1.36l2.44 2.37-.58 3.35a.8.8 0 0 0 1.16.84l3.01-1.58",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M38 6.31h-28a4 4 0 0 0-4 4v27.69a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-27.69a4 4 0 0 0-4-4Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "shield",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m31.14 21.18-8.3 8.3-4.98-4.98",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M38.7 12.34a22.54 22.54 0 0 1-12.93-5.37 1.98 1.98 0 0 0-2.54 0 22.64 22.64 0 0 1-12.93 5.37c-1.02.08-1.8.96-1.8 1.98v8.66c0 8.74 6.31 16.93 14.96 19.37.67.2 1.4.2 2.09 0 8.64-2.44 14.95-10.63 14.95-19.36v-8.66c0-1.03-.78-1.9-1.8-1.99Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "smileys",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M37.23 11.77a18 18 0 1 1-25.46 25.46 18 18 0 0 1 25.46-25.46m-19.73 6.73v2m14-2v2",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 32.5s2.63-2.62 7-2.62c4.38 0 7 2.62 7 2.62",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sort-bars",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12h-8",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 18,
    height: 18,
    rx: 2.25,
    transform: "rotate(180 21 21)",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16h-10m8-8h-6",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    id: "spectrum",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M22.42 16.5v6c0 .83-.67 1.5-1.5 1.5h-7.6m.08-4.5v-6c0-.83.67-1.5 1.5-1.5h7.6",
    stroke: "#3C00FF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.25 4.5h13.5a6.74 6.74 0 0 1 6.75 6.74v13.52a6.74 6.74 0 0 1-6.74 6.74h-13.52a6.74 6.74 0 0 1-6.74-6.74v-13.51a6.75 6.75 0 0 1 6.75-6.75v0Z",
    stroke: "#3C00FF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 9",
    fill: "none",
    id: "star-achievement",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m4.65 7.02 1.76.92c.34.18.74-.1.68-.49l-.34-1.95 1.42-1.38a.47.47 0 0 0-.26-.8l-1.96-.28-.88-1.78a.47.47 0 0 0-.83 0l-.88 1.78-1.96.28a.47.47 0 0 0-.26.8l1.42 1.38-.33 1.95c-.07.38.33.67.67.5l1.76-.93",
    stroke: "#3C00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "tg-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m23.59 33.81-4.13 4.02c-.72.7-1.91.39-2.2-.57l-2.76-9.06",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m28.2 21.85-7.83 7.07c-.79.72-.72 1.98.14 2.61l10.75 7.95a1.8 1.8 0 0 0 2.85-1.08l5.28-24.9a1.55 1.55 0 0 0-2.08-1.76l-31.03 11.97c-.9.35-.87 1.65.07 1.95l8.15 2.54",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    id: "tg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.25 4.5h13.5a6.74 6.74 0 0 1 6.75 6.74v13.52a6.74 6.74 0 0 1-6.74 6.74h-13.52a6.74 6.74 0 0 1-6.74-6.74v-13.51a6.75 6.75 0 0 1 6.75-6.75v0Z",
    stroke: "#3C00FF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.14 23.24-1.22-4.01-3.49-1.1a.44.44 0 0 1-.02-.83l13.27-5.12c.5-.19 1 .24.9.76l-2.24 10.51a.86.86 0 0 1-1.36.52l-3.17-2.34-1.86 1.81a.49.49 0 0 1-.8-.2v0Z",
    stroke: "#3C00FF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 264 88",
    fill: "none",
    id: "title-line-1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M109 14c-17.77-.93-118.97-8-105.33 34.28 8.07 25.04 52.15 30.8 73.39 33.83a423.2 423.2 0 0 0 103.27 2.11c19.65-2.05 70.43-3.5 80.28-25.05 10.74-23.48-29.3-37.67-44.61-41.4-67.14-16.3-134.5-16.35-203-14.77",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 291 72",
    fill: "none",
    id: "title-line-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M117.85 15.57c-16.24.06-151.76 6.45-106.73 35.95 45.53 29.83 245.82 21.88 273.83-11.87 10.12-12.18-.19-21.28-14.81-25.33-78.89-21.85-173.93-9.66-240.26-1.25",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 5",
    fill: "none",
    id: "title-line-straight",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97 2.12c56.36 1.56 95.97-1.35 136.06-.24",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 267 12",
    fill: "none",
    id: "title-line-straight2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5c82.5 3.5 182-7.5 263.5-7.5",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "user-circle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87 11.94a17.25 17.25 0 0 0-4.4 7.98m13.11 20.97a17.3 17.3 0 0 0 8.8-.38m-21.91-12.43c.74 3.06 2.28 5.8 4.4 7.98m28.94-7.13a17.28 17.28 0 0 1-4.42 7.35m0-24.56a17.3 17.3 0 0 1 4.42 7.35m-20.23-11.96a17.3 17.3 0 0 1 8.8.38",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M43.07 20.46a5 5 0 1 1-7.07 7.08 5 5 0 0 1 7.07-7.08m-25.42 14.68a5 5 0 1 1-7.07 7.07 5 5 0 0 1 7.07-7.07m0-29.35a5 5 0 1 1-7.07 7.07 5 5 0 0 1 7.07-7.07",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    id: "user-group",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M41.59 19.05a4.05 4.05 0 1 1-5.73 5.72 4.05 4.05 0 0 1 5.73-5.72m-13.19-7.23a6.23 6.23 0 1 1-8.8 8.82 6.23 6.23 0 0 1 8.8-8.82m-16.26 7.23a4.05 4.05 0 1 1-5.72 5.72 4.05 4.05 0 0 1 5.72-5.72m33.86 18.95v-2.2a5 5 0 0 0-5-5h-1.6m-37.4 7.2v-2.2a5 5 0 0 1 5-5h1.6m26.08 7.2v-3.2a7 7 0 0 0-7-7h-7.36a7 7 0 0 0-7 7v3.2",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    id: "user-refresh",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m21.83 42.5 2.67-2.66-2.67-2.67m20.46-8.66a4.67 4.67 0 0 1 2.22 3.55c0 3.27-5.2 6.07-12.56 7.22",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71 28.51a4.67 4.67 0 0 0-2.22 3.55c0 4.3 8.96 7.78 20.01 7.78",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M31.34 28.58h-13.68c-.64 0-1.16-.53-1.16-1.17v-.94a4.88 4.88 0 0 1 4.86-4.87h6.28a4.88 4.88 0 0 1 4.86 4.87v.94c0 .64-.52 1.16-1.16 1.17v0Zm-6.84-12.79a4.65 4.65 0 1 1 0-9.3 4.65 4.65 0 0 1 0 9.3v0Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    id: "vk",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.25 4.5h13.5a6.74 6.74 0 0 1 6.75 6.74v13.52a6.74 6.74 0 0 1-6.74 6.74h-13.52a6.74 6.74 0 0 1-6.74-6.74v-13.51a6.75 6.75 0 0 1 6.75-6.75v0Z",
    stroke: "#3C00FF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M16.03 14.47h1.82v9.11h0c-1.88 0-3.94-1.14-5.4-3.24-2.2-3.08-2.8-5.4-2.8-5.87m15.34 9.11s-.67-1.4-2.01-2.94a4.48 4.48 0 0 0-3.31-1.62c1.15 0 2.41-.57 3.3-1.62 1.35-1.53 2.02-2.93 2.02-2.93m-5.32 4.56h-1.82",
    stroke: "#3C00FF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    id: "yt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15 22.5 7.8-4.5-7.8-4.5v9Z",
    stroke: "#3C00FF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.25 4.5h13.5a6.74 6.74 0 0 1 6.75 6.74v13.52a6.74 6.74 0 0 1-6.74 6.74h-13.52a6.74 6.74 0 0 1-6.74-6.74v-13.51a6.75 6.75 0 0 1 6.75-6.75v0Z",
    stroke: "#3C00FF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.0f27648ba06c3f20f0affb4681654260.svg";
export { ForwardRef as ReactComponent };